import {createSvgIcon} from '../create-svg-icon';

export const DoneIcon = createSvgIcon(
  <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
, 'DoneOutlined');
